<template>
  <div class="countdown">
    <el-button
      class="getNumber"
      :style="countdownStyle"
      :disabled="disabled"
      @click="getCode"
      >
    {{ this.countDownType === 'reg' ? codeMsg: '登录' }}
    </el-button>
  </div>
</template>

<script>
// import { sendCode, getRegSMSCode, getLoginSMSCode, getSMSCode, getLoginRegSMSCode, getLoginRegEmailCode } from '@/api/modules/iam'
import {
  getLoginRegSMSCode,
  getLoginRegEmailCode,
  phoneSubmitPhone,
  emailSubmitPhone,
  resetSubmitPhone
} from '@/api/modules/iam'
import { pictureVerification } from '@/scripts/captcha'
import { getResetSubmitEmail } from '@/api/modules/forgotPassword'
// import vue from '@/main'

export default {
  name: 'CountDown',
  props: {
    phone: {
      type: String,
      default: () => {
        return ''
      }
    },
    email: {
      type: String,
      default: () => {
        return ''
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    urlType: {
      type: Number,
      default: 1
    },
    countdownStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    countDownType: {
      type: String,
      default: () => {
        return 'reg'
      }
    },
    isPhone: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      codeDisabled: true,
      countdown: 60,
      timer: null,
      codeMsg: '获取验证码'
    }
  },
  watch: {
    phone(val) {
      if (val) {
        var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(this.phone)) {
          this.codeDisabled = true
          this.countdownStyle.background = '#DDDDDD'
          this.countdownStyle.color = '#FFF'
        }
        else {
          console.log(this.phone, 'ops.phone')
          this.codeDisabled = false
          this.countdownStyle.background = '#4d78ff'
          this.countdownStyle.color = '#FFF'
        }
      }
      else {
        this.codeDisabled = true
      }
    },
    email(val) {
      if (val) {
        this.codeDisabled = false
        this.countdownStyle.background = '#4d78ff'
        this.countdownStyle.color = '#FFF'
      }
      else {
        this.codeDisabled = true
      }
    }

  },
  methods: {
    async resetCode() {
      clearInterval(this.timer)
      this.codeMsg = '获取验证码'
      this.countdown = 60
      this.timer = null
      this.codeDisabled = false
    },
    async getCode() {
      if (this.timer) return
      if (this.countDownType === 'reg') {
        if (this.phone !== '' || this.email !== '') {
          await this.checkCaptcha(this.form)
          // if (!checkRes.data) {
          //   return this.$message({
          //     message: checkRes.msg,
          //     type: 'error',
          //   })
          // }
          // TODO:后面抽时间优化成枚举
          // if (this.urlType === 1) {
          //   const res = await sendCode({ nation: '86', phone: this.phone })
          //   console.log(res)
          // }
          // else
          if (this.urlType === 6) {
            // 登录或者静默注册--手机号验证码
            try {
              const res = await getLoginRegSMSCode({ nation: '86', phone: this.phone, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else if (this.urlType === 7) {
            // 邮箱注册验证码
            try {
              const res = await getLoginRegEmailCode({ email: this.email + this.form.relationEnterpriseAddress, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else if (this.urlType === 8) {
            // 忘记密码
            try {
              const res = await getResetSubmitEmail({ email: this.email, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else if (this.urlType === 11) {
            // 通用功能- 手机号发送验证码
            try {
              const res = await phoneSubmitPhone({ nation: '86', phone: this.phone, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else if (this.urlType === 12) {
            // 通用功能- 邮箱发送验证码
            try {
              const res = await emailSubmitPhone({ email: this.email, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else if (this.urlType === 13) {
            // 手机号修改密码-发送验证码
            try {
              const res = await resetSubmitPhone({ nation: '86', phone: this.phone, captcha: this.form.captcha })
              if (res.code !== 0) {
                return this.$message({ message: res.msg, type: 'error' })
              }
              this.$message({ message: '发送成功！', type: 'success' })
            }
            catch (error) {
              return this.$message({ message: error.msg, type: 'error' })
            }
          }
          else {
            console.log('11')
          }
          this.$emit('handleClick', true)
          // 验证码60秒倒计时
          if (!this.timer) {
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--
                this.codeDisabled = true
                if (this.countdown !== 0) {
                  this.codeMsg = `${this.countdown}s`
                }
                else {
                  clearInterval(this.timer)
                  this.codeMsg = '重新获取验证码'
                  this.countdown = 60
                  this.timer = null
                  this.codeDisabled = false
                }
              }
            }, 1000)
          }
        }
        else {
          if (this.isPhone) {
            return this.$message({ message: '请先输入手机号！', type: 'warning' })
          }
          else {
            return this.$message({ message: '请先输入邮箱！', type: 'warning' })
          }
        }
      }
      else {
        if (this.phone !== '' || this.email !== '') {
          if (this.urlType === 9) {
            if (this.isNull(this.form.phonePassword)) {
              this.$message({ message: '请输入密码', type: 'warning' })
              return null
            }
          }
          else if (this.urlType === 10) {
            if (this.isNull(this.form.emailPassword)) {
              this.$message({ message: '请输入密码', type: 'warning' })
              return null
            }
          }
          await this.checkCaptcha(this.form)
          this.$emit('logInClickBtn')
        }
        else {
          if (this.isPhone) {
            return this.$message({ message: '请先输入手机号！', type: 'warning' })
          }
          else {
            return this.$message({ message: '请先输入邮箱！', type: 'warning' })
          }
        }
      }
    },
    async checkCaptcha(form) {
      try {
        const res = await pictureVerification()
        form.captcha = {
          ticket: res.ticket,
          randStr: res.randstr
        }
      }
      catch (error) {
        console.log('checkCaptcha:', error)
        this.$message({
          message: '图形验证码错误',
          type: 'error'
        })
        this.$emit('handleClick', false)
        throw new Error('图形验证码错误')
      }
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    }
  }
}
</script>

<style lang="less" scoped>
  .countdown {
    .getNumber{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      background: #4d78ff !important;
    }
  }
  .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    border-color: transparent;
}
</style>
